// The A1 "First words" starter set — ~36 essential phrases a brand-new learner
// can pick up on day one, before they've generated anything from sentence
// practice. Hand-picked (no AI), grouped loosely greeting → courtesy → meeting
// people → survival. Used by the Starter view (src/views/starter.js).
export const STARTER_PHRASES = [
  { es: "Ciao", en: "Hi / Bye (informal)" },
  { es: "Buongiorno", en: "Good morning / Hello" },
  { es: "Buon pomeriggio", en: "Good afternoon" },
  { es: "Buonasera", en: "Good evening" },
  { es: "Buonanotte", en: "Good night" },
  { es: "Arrivederci", en: "Goodbye" },
  { es: "A dopo", en: "See you later" },
  { es: "A domani", en: "See you tomorrow" },

  { es: "Per favore", en: "Please" },
  { es: "Grazie", en: "Thank you" },
  { es: "Grazie mille", en: "Thank you very much" },
  { es: "Prego", en: "You're welcome" },
  { es: "Scusa", en: "Sorry / Excuse me (informal)" },
  { es: "Mi dispiace", en: "I'm sorry" },
  { es: "Permesso", en: "Excuse me (to get past)" },

  { es: "Come stai?", en: "How are you? (informal)" },
  { es: "Come sta?", en: "How are you? (formal)" },
  { es: "Bene, grazie", en: "Fine, thanks" },
  { es: "Così così", en: "So-so" },
  { es: "E tu?", en: "And you?" },

  { es: "Mi chiamo…", en: "My name is…" },
  { es: "Come ti chiami?", en: "What's your name?" },
  { es: "Piacere", en: "Nice to meet you" },
  { es: "Sono di…", en: "I'm from…" },
  { es: "Di dove sei?", en: "Where are you from?" },

  { es: "Sì", en: "Yes" },
  { es: "No", en: "No" },
  { es: "Non lo so", en: "I don't know" },
  { es: "Non capisco", en: "I don't understand" },
  { es: "Parli inglese?", en: "Do you speak English?" },
  { es: "Puoi ripetere, per favore?", en: "Can you repeat, please?" },
  { es: "Più lentamente, per favore", en: "Slower, please" },
  { es: "Come si dice…?", en: "How do you say…?" },
  { es: "Cosa significa…?", en: "What does … mean?" },
  { es: "Quanto costa?", en: "How much is it?" },
  { es: "Dov'è il bagno?", en: "Where is the bathroom?" },
  { es: "Aiuto, per favore", en: "Help, please" },
];
